<template>
    <div class="tab-pane active">
        <h5 class="mt-3">
            {{ $t('Locked dates in booking') }}
            <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_booking_disabled_date')">
                {{ $t('Create') }}
            </app-button>
        </h5>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Date') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(date, i) in dates" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ date.date | formatDate }}</td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_booking_disabled_date', {date})" small>
                                {{ $t('Edit') }}
                            </app-button>
                            <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy(date.id)" small>
                                {{ $t('Delete') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <create-modal @setDate="setDate"/>
        <update-modal @setDate="setDate"/>
    </div>
</template>

<script>
import BookingDisabledDateService from '@services/bookingLockedDate.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            dates: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getDates() {
            BookingDisabledDateService.dates().then(res => this.dates = res);
        },
        setDate(date) {
            const index = this.dates.findIndex(d => d.id === date.id);
            if(index !== -1) {
                Vue.set(this.dates, index, date);
            } else {
                this.dates.push(date);
            }
        },
        destroy(dateId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            BookingDisabledDateService.destroy(dateId).then(res => {
                const index = this.dates.findIndex(d => d.id === dateId);
                this.dates.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal
    },
    created() {
        this.getDates();
    },
    metaInfo() {
        return {
            title: this.$t('Locked dates in booking')
        };
    }
};
</script>
